import { combineReducers } from 'redux'
import locale from './locale'

export default combineReducers({ locale })
